import { MASTER_SELECTION_CONTEXT } from './selectionContext';
import getMasterIdsFromSelectionEntry from './getMasterIdsFromSelectionEntry';
import toSelectionEntry from './toSelectionEntry';

export function readSoleSelectionEntry(selection) {
  if (selection?.keys?.length !== 1) return null;
  return selection.byKey?.[selection.keys[0]] || null;
}

export default function restoreMasterSelectionIfSoleDraftRemoved(state, {
  masterProductId,
  soleEntry,
  source,
} = {}) {
  const selection = state.ui?.selection;
  if (!selection || selection.keys.length || !soleEntry || !masterProductId) return;

  const { productId, variantId } = getMasterIdsFromSelectionEntry(soleEntry);
  if (!productId || String(productId) !== String(masterProductId)) return;

  const item = variantId
    ? { type: 'masterVariant', _id: variantId, baseProductId: masterProductId }
    : { type: 'master', _id: masterProductId };
  const entry = toSelectionEntry(item);

  state.ui.selection = {
    keys: [entry.key],
    byKey: { [entry.key]: entry },
    lastClickedKey: entry.key,
    isComplete: false,
    context: MASTER_SELECTION_CONTEXT,
    source: source ?? null,
  };
}
